import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import secret from './js/secret'

Vue.use(VueAxios, axios);

axios.defaults.withCredentials = true;
axios.interceptors.request.use(
    config => {
      let timestamp = new Date().getTime().toString();
      window.console.log('==== interceptors === ' + timestamp);
      config.headers.WATCH_DD = 'uYJDovQ7Mt1JnqRX';
      config.headers.WATCH_TT = secret.Encrypt(timestamp);
      return config;
    },
    error => {
      return Promise.reject(error);
    }
);


Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');